import type ICoProducer from 'interfaces/ICoProducer';
class CoProducer implements ICoProducer {
  affiliate_manager: boolean = this.coproducer.affiliate_manager || false;
  business_name: string = this.coproducer.business_name || '';
  email: string = this.coproducer.email || '';
  fiscal_document: boolean = this.coproducer.fiscal_document || false;
  only_over_affiliates: boolean = this.coproducer.only_over_affiliates || false;
  permission_refund: boolean = this.coproducer.permission_refund || false;
  comission_type: string = this.coproducer.comission_type || 'P';
  customer_id: number = this.coproducer.customer_id || 0;
  comission_value: number = this.coproducer.comission_value || 0;
  active: boolean = this.coproducer.active || false;
  visibility_customer_email: boolean = this.coproducer.visibility_customer_email || false;
  new: boolean = this.coproducer.new || false;
  edited: boolean = this.coproducer.edited || false;
  pending: boolean = this.coproducer.pending || false;
  isDeliveryPartner: boolean = this.coproducer.isDeliveryPartner || false;

  constructor(private coproducer: Partial<ICoProducer> = {}) {}
}

export default CoProducer;
